module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAuCAYAAABTTPsKAAABLklEQVRYhe3YsU4CQRCA4R81VnY0SrRRSZBnsDQWvoCNlS29b2RiS2XlK0iniZBYKbUPYLQ5jDnnnN3bneWK+ZoNc+HuzwW4sOCcK6onDed7J1+lQ2ougPvVi+Hy+efAxjpqAog3EmBLeeMN8Ji3Jcis6YAWPAVe8rak0T4SB0UqImh3+Ldr4NQqJODaQFzwJXCevyVIq+C3ar0FXoHPnEU1PaAPTOoHYoJX9o/fn66SkxSLwXhEpuC76oSpTZpNadjmwbGbGBJqKA27+qQDmEvDLgeLX+ouB4s82JoHW/Ngax5szYOtebA1D7bmwda04MZNuXXRgreLVERo+pt/Vq3SLuKHUUvdUho2BT/8c6Kjah0l5egOpWGbjZTJYjD+syNTSsyvxI5ZhXOuu74BthwdBf0rZhQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/copy-campaign.png
// module id = 1252
// module chunks = 0